import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const Analytics = ({ measurementId }: { measurementId: string }) => {
  const location = useLocation();

  useEffect(() => {
    // Initialize dataLayer first (exactly like the basic approach)
    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    // Load the script
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;

    // Basic initialization (matching the working approach exactly)
    script.onload = () => {
      gtag('js', new Date());
      gtag('config', measurementId);
    };

    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, [measurementId]);

  // Track route changes
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname,
        send_to: measurementId
      });
    }
  }, [location, measurementId]);

  return null;
};

export default Analytics;